import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`, // Correct development server URL
    // baseURL: 'https://wh.sklfc.com/inout-api/api', // Correct development server URL
    timeout: 100000,
    // timeout: 30000, // Set timeout to 30 seconds
});

// Request interceptor to add Authorization header
axiosInstance.interceptors.request.use(
    function (config) {
        const token = JSON.parse(localStorage.getItem('token'));
        if (token) {
        // config.headers['Authorization'] = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImRiYmI1MzE1LTk4ZjAtNDc5Yi04NTJhLWNiOWFiOGViMDA2YyIsImlhdCI6MTcyNjczMzMyOSwiZXhwIjoxNzI5MzI1MzI5fQ.qMuc1_7mrbz0AkbTNTxmNLLPFkD1UXrRfcqlS6NfiI4`;
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers["ngrok-skip-browser-warning"]= "1" ;
    return config;
},
function (error) {
    return Promise.reject(error);
}
);

const localVersion = localStorage.getItem('frontend_version');
axiosInstance.interceptors.response.use(
    function (response) {
        localStorage.setItem('frontend_version',response.headers.get('frontend_version'))
        if(localVersion === response?.headers?.frontend_version){
            return response;
        } else if(localVersion == null || localVersion == undefined || localVersion == 'undefined' || localVersion == 'null'){
            return response;
        } else{
            localStorage.clear();
            window.location.href = '/';
            
        }
        // return response;
    },
    function (error) {
        if (error?.response?.status === 401) {
            // toast.error(error?.response?.data?.message)
            localStorage.clear();
            window.location.href = '/';
        }
        // Handle network errors (no response from server)
        if (!error?.response) {
            // Check if it's a cancellation - we should still throw for cancellations to let callers handle them specifically
            if (axios.isCancel?.(error) || error.name === 'CanceledError' || error.name === 'AbortError') {
                throw error;
            }

            // Return a mocked failed response instead of throwing
            return {
                data: {
                    success: false,
                    msg: error.message || 'Network Error: Could not connect to the server',
                    isNetworkError: true
                },
                status: 0,
                statusText: 'Network Error'
            };
        }
        
        // Return error response for other status codes (e.g. 400, 500)
        return error?.response;
    }
);
export default axiosInstance;
